import { seedTranslations } from './seed';

/**
 * Resolves the translation dictionary the app renders from, with the static
 * seed as a last-resort floor under the server dictionary.
 *
 * - No server translations yet (loading, or none provided): the seed floor,
 *   so the error boundary and Narvar footer always render (in English).
 * - Valid server JSON: the server wins, so these strings follow the user's
 *   locale once the catalog carries localized values. (The footer and
 *   error-boundary keys aren't exposed in the admin content editor, so
 *   retailers still can't change them — the seed is purely a fallback.)
 * - Present but unparseable: a hard failure. Translations are a hard
 *   dependency, so we throw rather than silently render a stripped UI; the
 *   top-level error boundary then renders from the seed (logged once, with the
 *   original parse error preserved as `cause`).
 */
export const resolveTranslations = (
  rawJson?: string,
): Record<string, string> => {
  if (!rawJson) return seedTranslations;

  let parsed: Record<string, string>;
  try {
    parsed = JSON.parse(rawJson) as Record<string, string>;
  } catch (error) {
    throw new Error('Failed to load retailer translations', { cause: error });
  }

  return { ...seedTranslations, ...parsed };
};
